import(/* webpackMode: "eager" */ "/app/src/app/article/[slug]/error.tsx");
